import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "react-bootstrap";
import "./ImportarAtributos.css";
import Select from "react-select";
import { UsuarioContext } from "../Context/Usuario";
import log from "loglevel";
import UAI from "../UAI";
import Loading from "../Utils/Loading";

const ImportarAtributosModal = (props) => {
  const { usuario } = useContext(UsuarioContext);
  const selectCohorteRef = useRef();
  const selectAtributosRef = useRef();

  const [cohorteSeleccionado, setCohorteSeleccionado] = useState(0);
  const [
    detallesCohorteSeleccionado,
    setDetallesCohorteSeleccionado,
  ] = useState(null);
  const [atributosOptions, setAtributosOptions] = useState([]);
  const [atributosSeleccionados, setAtributosSeleccionados] = useState([]);
  const [cohortesOptions, setCohortesOptions] = useState([]);
  const [confirmado, setConfirmado] = useState(false);
  const [errores, setErrores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.cohorte === undefined || props.cohorte === null) {
      return;
    }

    let options = [];
    // Se construye el arreglo para autocompletar atributos
    Object.values(usuario.atributos).forEach((atributo) => {
      options.push({ value: atributo.key, label: atributo.Nombre });
      for (let idf in props.fields) {
        if (
          props.fields[idf] === atributo.key &&
          atributo.key !== "habilitado"
        ) {
          seleccionados.push(atributo.key);
        }
      }
    });
    // Ordenamos alfabéticamente
    options.sort(function (a, b) {
      let sa = a.label;
      let sb = b.label;
      return sa.localeCompare(sb);
    });

    // Arreglo para automcompletar cohortes, todas las del usuario excepto a la que se copiará
    let optionscohortes = Object.values(usuario.cohortes).reduce(
      (prev, current) => {
        if (current.id !== props.cohorte.id) {
          // Agregamos la facultad/escuela al nombre para facilitar la desambiguación
          let facultad = UAI.obtieneFacultadPorId(current.FacultadId) || {
            nombre: "",
          };
          prev.push({
            value: current.id,
            label:
              current.año_inicio +
              "-" +
              facultad.nombre +
              "-" +
              current.id +
              "-" +
              current.nombre,
          });
        }
        return prev;
      },
      []
    );
    // Ordenamos alfabéticamente
    optionscohortes.sort(function (a, b) {
      let sa = a.label;
      let sb = b.label;
      return sb.localeCompare(sa);
    });

    setAtributosOptions(options);
    setCohortesOptions(optionscohortes);
  }, [props.cohorte, props.fields, usuario]);

  /**
   * Guardamos la cohorte seleccionada en la variable de estado
   * @param {*} element
   */
  const guardarCohorteSeleccionado = (element) => {
    if (element && element.value !== 0) {
      let index = errores.indexOf("cohorte");
      if (index >= 0) {
        errores.splice(index, 1);
        setErrores(errores);
      }
      setCohorteSeleccionado(element.value);
    }
  };

  const guardarAtributosSeleccionados = (element) => {
    if (!element || !Array.isArray(element)) {
      return;
    }
    let atributos = [];
    for (var idx in element) {
      var el = element[idx];
      atributos.push(el.value);
    }
    let index = errores.indexOf("atributos");
    if (index >= 0) {
      errores.splice(index, 1);
      setErrores(errores);
    }
    setAtributosSeleccionados(atributos);
  };

  const guardarCambios = () => {
    if (cohorteSeleccionado === 0) {
      alert(
        "No way. Debe primero seleccionar un cohorte para importar. ID:" +
          cohorteSeleccionado
      );
      return;
    }
    if (atributosSeleccionados.length <= 0) {
      alert("No way. Debe primero seleccionar atributos a importar");
      return;
    }
    let atributosActualizar = atributosSeleccionados.reduce((prev, current) => {
      prev.push({
        Codigo: current,
        Valor: detallesCohorteSeleccionado[0][current],
      });
      return prev;
    }, []);
    setLoading(true);
    UAI.actualizaAtributos(
      usuario.username,
      props.cohorte.id,
      atributosActualizar,
      (result) => {
        if (!result || !Array.isArray(result)) {
          resetEstadoInterfaz();
          return;
        }
        let errores = UAI.obtieneErroresActualizacionAtributosCohortes(
          result[0]
        );
        if (errores) {
          log.error(errores);
          resetEstadoInterfaz();
          return;
        } else {
          // No hay errores en la actualización
          resetEstadoInterfaz();
          props.cerrar();
        }
      },
      (error) => {
        log.error(error);
        resetEstadoInterfaz();
      }
    );
  };

  const resetEstadoInterfaz = () => {
    setCohorteSeleccionado(0);
    setAtributosSeleccionados([]);
    setConfirmado(false);
    setLoading(false);
  };

  const confirmarCambios = () => {
    let _errores = [];
    if (cohorteSeleccionado < 1) {
      _errores.push("cohorte");
    }
    if (atributosSeleccionados.length < 1) {
      _errores.push("atributos");
    }
    if (_errores.length > 0) {
      setErrores(_errores);
      return;
    }
    UAI.obtieneDetallesCohortesPorId(
      [cohorteSeleccionado],
      (result) => {
        setDetallesCohorteSeleccionado(result);
        setConfirmado(true);
      },
      (error) => {
        log.error(error);
      },
      atributosSeleccionados
    );
  };

  const limpiarAtributos = () => {
    log.debug("Limpiar atributos");
    selectAtributosRef.current.select.clearValue();
    selectCohorteRef.current.select.clearValue();
    setCohorteSeleccionado(0);
    setAtributosSeleccionados([]);
    setConfirmado(false);
    setErrores([]);
  };

  const cerrar = () => {
    setCohorteSeleccionado(0);
    setAtributosSeleccionados([]);
    setConfirmado(false);
    setErrores([]);
    props.cerrar();
  };

  if (
    props.cohorte === undefined ||
    props.cohorte === null ||
    !cohortesOptions ||
    !Array.isArray(cohortesOptions) ||
    cohortesOptions.length === 0
  ) {
    return <div></div>;
  }

  return (
    <div>
      <Modal className="ImportarAtributos" show={props.isOpen} onHide={cerrar}>
        <Modal.Header>
          Importando atributos a {props.cohorte.nombre}
        </Modal.Header>
        <Modal.Body>
          {loading && <Loading small={true} />}
          {!loading && (
            <Form>
              <FormGroup>
                <Form.Label>Importar desde</Form.Label>
                <Select
                  id="idcohorte"
                  ref={selectCohorteRef}
                  closeMenuOnSelect={true}
                  isClearable
                  options={cohortesOptions}
                  onChange={guardarCohorteSeleccionado}
                />
                <div className="text-danger">
                  {errores.indexOf("cohorte") >= 0 &&
                    "Debe indicar una cohorte desde donde copiaremos los datos"}
                </div>
              </FormGroup>
              <FormGroup>
                <Form.Label>Atributos a importar</Form.Label>
                <Select
                  id="atributos"
                  ref={selectAtributosRef}
                  closeMenuOnSelect={true}
                  isMulti
                  isClearable
                  options={atributosOptions}
                  onChange={guardarAtributosSeleccionados}
                />
                <div className="text-danger">
                  {errores.indexOf("atributos") >= 0 &&
                    "Debe indicar qué atributos copiaremos"}
                </div>
              </FormGroup>
            </Form>
          )}
          {!loading &&
            confirmado &&
            detallesCohorteSeleccionado &&
            detallesCohorteSeleccionado[0] &&
            atributosSeleccionados.length > 0 && (
              <div>
                <p>Importaremos los siguientes valores</p>
                <ul>
                  {atributosSeleccionados.map((atributo, idx) => {
                    return (
                      <li key={idx}>
                        <strong>
                          Atributo: {usuario.atributos[atributo].Nombre}
                        </strong>
                        <br />
                        Valor: {detallesCohorteSeleccionado[0][atributo]}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
        </Modal.Body>
        {!loading && (
          <Modal.Footer>
            {!confirmado && (
              <Button variant="primary" onClick={confirmarCambios}>
                Confirmar datos a importar
              </Button>
            )}
            {confirmado && (
              <>
                <Button variant="primary" onClick={guardarCambios}>
                  Importar atributos
                </Button>
                <Button variant="outline-primary" onClick={limpiarAtributos}>
                  Limpiar atributos
                </Button>
              </>
            )}
            <Button variant="secondary" onClick={cerrar}>
              Cerrar
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
};

export default ImportarAtributosModal;
